export default "__VITE_ASSET__CU5GzF5s__"